<template>
  <div class='max-w-[80rem]'>
    <dl class="mt-5 flex flex-col gap-5 sm:flex-row">
      <div v-for="item in props.stats" :key="item.name" class="overflow-hidden rounded-lg bg-gray-50 px-4 py-5 sm:p-6 flex-1" :class='!props.isPrint ? "shadow" : ""'>
        <dt class="truncate text-sm font-medium text-gray-500">{{ item.name }}</dt>
        <dd class="mt-1 text-3xl font-semibold tracking-tight text-gray-900">{{ item.value }}</dd>
      </div>
    </dl>
  </div>
</template>

<script setup>

const props = defineProps({
  stats: Array,
  isPrint: Boolean
});

</script>
